import { Text } from "@ottatech/design";

import { IDashboardBannerNotification } from "..";

import { Link } from "components/Link";
import { Notification } from "schema";

const CanadaJobsContent: React.FC = () => (
  <>
    <Text>
      Jobs in Canada are now live!{" "}
      <Link
        to="/preferences/location"
        underline={false}
        data-testid="link-canada-jobs-notification"
        data-analytics-id="link-canada-jobs-notification"
      >
        Update your preferences
      </Link>{" "}
      to get matched today.
    </Text>
  </>
);

export const CanadaJobsNotification: IDashboardBannerNotification = {
  key: "canada-jobs-notification",
  name: Notification.CanadaJobs,
  Content: CanadaJobsContent,
  level: "positive",
};
